import BaseModelInstance from './base.model'
import { CarrierFmo as ModelDefinition } from './model-definitions'

class CarrierFmo extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default CarrierFmo
